import request from '@/common/request/request_common'



function getOne(data) { return request({ url: '/Order/GetOne', method: 'post', data }) }

function getList(data) { return request({ url: '/Order/GetList', method: 'post', data }) }

function postOrderCreate(data) { return request({ url: '/Order/Create', method: 'post', data }) }

function postOrderCalcAmount(data) { return request({ url: '/Order/CalcAmount', method: 'post', data }) }

function wxPayQrCode(data) { return request({ url: '/WxPay/Native', method: 'post', data }) }

function wxPayPreId(data) { return request({ url: '/WxPay/CreateOrderByJsapi', method: 'post', data }) }


export default {
  getOne,
  getList,
  postOrderCreate,
  postOrderCalcAmount,
  wxPayQrCode,
  wxPayPreId,
}
